import * as React from 'react';
export const jaywanSvg = React.forwardRef(function jaywanSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#003D52',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M12.416 5v2.174l-3.5 3.501V8.501L12.415 5ZM11.24 15.077l3.39-3.411c.4-.4.931-.62 1.498-.62h5.135v5.155c0 .565-.22 1.096-.62 1.497L11.34 27h4.576l7.257-7.257a4.495 4.495 0 0 0 1.326-3.198V7.83h-8.715a4.49 4.49 0 0 0-3.198 1.326l-2.983 2.983c-4.356 4.356-1.107 9.154 2.181 9.154h3.1l3.211-3.221H12.64c-1.718 0-2.397-1.995-1.397-2.995Z',
      fill: '#CC9E2B',
    }),
  );
});
jaywanSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var jaywan = {
  category: 'brand',
  colorable: false,
  name: 'jaywan',
  svg: jaywanSvg,
};
